webpackJsonp([50739212244294],{

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.tagPageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagRoute = function (_Component) {
	  _inherits(TagRoute, _Component);
	
	  function TagRoute() {
	    _classCallCheck(this, TagRoute);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TagRoute.prototype.render = function render() {
	    var posts = this.props.data.allMarkdownRemark.edges;
	    var postLinks = posts.map(function (post) {
	      return _react2.default.createElement(
	        'li',
	        { key: post.node.fields.slug },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: post.node.fields.slug },
	          _react2.default.createElement(
	            'h2',
	            { className: 'is-size-2' },
	            post.node.frontmatter.title
	          )
	        )
	      );
	    });
	    var tag = this.props.pathContext.tag;
	    var title = this.props.data.site.siteMetadata.title;
	    var totalCount = this.props.data.allMarkdownRemark.totalCount;
	    var tagHeader = totalCount + ' post' + (totalCount === 1 ? '' : 's') + ' tagged with \u201C' + tag + '\u201D';
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'section' },
	      _react2.default.createElement(_reactHelmet2.default, { title: tag + ' | ' + title }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'column is-10 is-offset-1',
	              style: { marginBottom: '6rem' }
	            },
	            _react2.default.createElement(
	              'h3',
	              { className: 'title is-size-4 is-bold-light' },
	              tagHeader
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'taglist' },
	              postLinks
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/tags/' },
	                'Browse all tags'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return TagRoute;
	}(_react.Component);
	
	exports.default = TagRoute;
	var tagPageQuery = exports.tagPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tags-js-a235edea59eb173b6dd5.js